function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ReportTabGeneral from '@/modules/tasks/datastudio/components/ReportTabGeneral.vue';
import ReportTabPage from '@/modules/tasks/datastudio/components/ReportTabPage';
import ReportTabDatasource from '@/modules/tasks/datastudio/components/ReportTabDatasource';
import ReportTabBusinessTerm from '@/modules/tasks/datastudio/components/ReportTabBusinessTerm';
import TabHistoryLogView from '@/components/tableau/TabHistoryLogView';
import ReportTabUserGds from '@/modules/tasks/datastudio/components/ReportTabUserGDS.vue';
import ReportTabLineage from '@/modules/tasks/datastudio/components/ReportTabLineage.vue';
import DatastudioReportService from '@/apps/data-platform/services/visualization/datastudio_report_service';
import { ACCESS_TYPE_FLOW, ENVIRONMENT_FLOW, GA_EVENTS } from '@/js/constants';
import tasks from '@/js/tasks';
import { mapState } from 'vuex';
export default {
  name: 'FormMetaReportDatastudio',
  components: {
    ReportTabGeneral: ReportTabGeneral,
    ReportTabPage: ReportTabPage,
    ReportTabDatasource: ReportTabDatasource,
    ReportTabUserGds: ReportTabUserGds,
    ReportTabBusinessTerm: ReportTabBusinessTerm,
    TabHistoryLogView: TabHistoryLogView,
    ReportTabLineage: ReportTabLineage
  },
  props: {
    item: {
      type: Object,
      default: function _default() {}
    },
    report_id: {
      type: String,
      default: ''
    },
    isChangeRequest: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    showButtons: {
      type: Boolean,
      default: true
    },
    validateLink: {
      type: Boolean,
      default: false
    },
    show_url: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      email_regex: new RegExp('[a-z0-9]+@[a-z]+\.[a-z]{2,3}\.[a-z]{2,3}'),
      dismissCountDown: 0,
      dismissSecs: 8,
      dangerMessage: '',
      response_text: '',
      showDownloadCsv: true,
      showBtnAceptar: true,
      txtCancelar: 'Cancel',
      environt_initial: '',
      objetoInicial: null,
      valid: {
        organization: true,
        data_operator: true,
        kdomain: true,
        ksubdomain: true,
        object_description: true,
        response_text: true
      },
      ACCESS_TYPE_FLOW: ACCESS_TYPE_FLOW,
      tabActive: 'GENERAL',
      key_lineage: 1,
      tab: null,
      validform: true
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode', 'companyName'])), {}, {
    isShowWorkFlow: function isShowWorkFlow() {
      return this.isChangeRequest === 'APPROVE_OWNER';
    },
    composeName: function composeName() {
      return "REPORT: ".concat(this.item.path_name, "/").concat(this.item.object_name).replace(/\//g, '&nbsp;/&nbsp;');
    }
  }),
  created: function created() {
    this.environt_initial = this.item['environment'];
    this.objetoInicial = JSON.parse(JSON.stringify(this.item));
    this.getReportById();
    console.log(this.item);
  },
  methods: {
    getListTerminosNegocio: function getListTerminosNegocio(listTerms) {
      console.log("list terms:", listTerms);
      this.item.business_terms = listTerms;
    },
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    onChangeDatasource: function onChangeDatasource(conexiones) {
      this.key_lineage += 1;
    },
    getReportById: function getReportById() {
      var _this = this;
      if (this.report_id) {
        var param = {
          report_id: this.report_id
        };
        DatastudioReportService.getReportById(param).then(function (datos) {
          // //this.$emit('update:item.business_terms', datos.data.business_terms)
          _this.item.bussines_terms = datos.data.bussines_terms;
        });
      }
    },
    onCancel: function onCancel() {
      this.$emit('onCloseModal');
    },
    onReject: function onReject() {
      var _this2 = this;
      if (this.response_text.trim() === '') {
        this.valid_response_text = false;
        this.dangerMessage = 'Please complete Response reason';
        this.dismissCountDown = this.dismissSecs;
        return;
      }
      var data = _objectSpread(_objectSpread({
        response: this.ds_response_text,
        domain: window.userInfo.domain
      }, this.item), {}, {
        status: 'REJECTED',
        type_flow: this.isChangeRequest
      }, this.document_id);
      DatastudioReportService.reportSendAssignment(data).then(function (res) {
        if (res.code === 200 && res.success) {
          tasks.toast.success('Solicitud rechazada correctamente.');
          if (_this2.$gtm.enabled() && window.dataLayer) {
            window.dataLayer.push({
              event: GA_EVENTS.OWNERSHIP,
              object: 'lds_report',
              domain_object: _this2.item.organization,
              operator: _this2.stringToHash(_this2.item.data_operator),
              company_code: _this2.companyCode,
              id_object: _this2.item.object_name,
              hash_email: _this2.stringToHash(userInfo.email),
              module: 'data_platform',
              status: 'rejected'
            });
          }
          _this2.onCancel();
        } else {
          tasks.toast.error(res.message);
        }
      });
    },
    onSave: function onSave() {
      var _this3 = this;
      var responseText = this.response_text;
      var formElement = this.$refs.form;
      console.log("form:", formElement.validate());
      if (formElement.validate()) {
        if (this.isChangeRequest === ACCESS_TYPE_FLOW.ASSIGN_DATA_OPERATOR) {
          if (this.validateLink) {
            console.log('validar link: ', this.item.urlStatus);
            if (this.item.urlStatus != true && this.item.has_api != true) {
              tasks.toast.error('You must check the access link!');
              //this.$toast.warning('You must check the access link!')
              return;
            }
          }
          if (this.item.environment === ENVIRONMENT_FLOW.DEV) {
            var report = {
              domain: window.userInfo.domain,
              report: this.item
            };
            if (this.item.report_id) {
              DatastudioReportService.reportAddUpdate(report).then(function (res) {
                if (res && res.code === 200) {
                  if (res.success) {
                    tasks.toast.success('Report fields updated!');
                    //this.$toast.success('Report fields updated!')
                    _this3.onCancel();
                    _this3.$emit('onSave', report.report);
                  } else {
                    tasks.toast.error(res.message);
                    //this.$toast.warning(res.message)
                    _this3.onCancel();
                  }
                }
              });
            } else {
              DatastudioReportService.saveReport(report).then(function (res) {
                if (res && res.code === 200) {
                  if (res.success) {
                    tasks.toast.success('Report fields created!');
                    //this.$toast.success('Report fields created!')
                    _this3.onCancel();
                    _this3.$emit('onSave', report.report);
                  } else {
                    tasks.toast.error(res.message);
                    //this.$toast.warning(res.message)
                    _this3.onCancel();
                  }
                }
              });
            }
          } else {
            if (!(this.item.pages && this.item.pages.length > 0)) {
              tasks.toast.error('Enter at least 1 page!');
              //this.$toast.warning('Enter at least 1 page!')
              return;
            }
            if (!(this.item.datasources && this.item.datasources.length > 0)) {
              tasks.toast.error('Enter at least 1 datasource!');
              //this.$toast.warning('Enter at least 1 datasource!')
              return;
            }
            if (this.item.report_id) {
              var _report = {
                domain: window.userInfo.domain,
                comentary: this.ds_response_text,
                report: this.item
              };
              this.$set(this.item, 'type_flow', 'APPROVE_OWNER');
              this.$set(this.item, 'report_id', this.item.report_id);
              DatastudioReportService.reportInitWorkFlow(_report).then(function (res) {
                if (res && res.code === 200) {
                  if (res.success) {
                    tasks.toast.success('Successful request, Ownership workflow in progress!');
                    if (_this3.$gtm.enabled() && window.dataLayer) {
                      window.dataLayer.push({
                        event: GA_EVENTS.ASSIGN_OPERATOR,
                        object: 'pbi_report',
                        domain_object: _this3.item.organization,
                        operator: _this3.stringToHash(_this3.item.data_operator),
                        company_code: _this3.companyCode,
                        id_object: _this3.item.object_name,
                        hash_email: _this3.stringToHash(userInfo.email),
                        module: 'data_platform'
                      });
                    }
                    //this.$toast.success('Successful request, Ownership workflow in progress!')
                    _this3.onCancel();
                  } else {
                    tasks.toast.error(res.message);
                    //this.$toast.warning(res.message)
                    _this3.onCancel();
                  }
                }
              });
            } else {
              // primero insertar luego iniciar workflow
              var report1 = {
                domain: window.userInfo.domain,
                report: this.item
              };
              DatastudioReportService.saveReport(report1).then(function (res) {
                _this3.isSend = false;
                console.log('res: ', res);
                if (res && res.code === 200) {
                  if (res.success) {
                    _this3.item.report_id = res.data.report_id;
                    _this3.item.luid = res.data.luid;
                    var _report2 = {
                      domain: window.userInfo.domain,
                      comentary: _this3.ds_response_text,
                      report: _this3.item
                    };
                    _this3.$set(_this3.item, 'type_flow', 'APPROVE_OWNER');
                    _this3.$set(_this3.item, 'report_id', _this3.item.report_id);
                    DatastudioReportService.reportInitWorkFlow(_report2).then(function (res) {
                      if (res && res.code === 200) {
                        if (res.success) {
                          tasks.toast.success('Successful request, Ownership workflow in progress!');
                          //this.$toast.success('Successful request, Ownership workflow in progress!')
                          _this3.onCancel();
                        } else {
                          tasks.toast.error(res.message);
                          //this.$toast.warning(res.message)
                          _this3.onCancel();
                        }
                      }
                    });
                  } else {
                    tasks.toast.error(res.message);
                    //this.$toast.warning(res.message)
                  }
                }
              });
            }
          }
        } else if (this.isChangeRequest === ACCESS_TYPE_FLOW.APPROVE_OWNER) {
          var data = _objectSpread(_objectSpread({
            response_text: responseText,
            domain: window.userInfo.domain
          }, this.item), {}, {
            status: 'APPROVED',
            type_flow: 'APPROVE_OWNER'
          });
          DatastudioReportService.reportSendAssignment(data).then(function (res) {
            if (res.code === 200 && res.success) {
              tasks.toast.success('Now this report will available in "My Objects / My GDS Reports"');
              //this.$toast.success('Now this report will available in "My Objects / My GDS Reports"')
              if (_this3.$gtm.enabled() && window.dataLayer) {
                window.dataLayer.push({
                  event: GA_EVENTS.OWNERSHIP,
                  object: 'lds_report',
                  domain_object: _this3.item.organization,
                  operator: _this3.stringToHash(_this3.item.data_operator),
                  company_code: _this3.companyCode,
                  id_object: _this3.item.object_name,
                  hash_email: _this3.stringToHash(userInfo.email),
                  module: 'data_platform',
                  status: 'accepted'
                });
              }
              _this3.onCancel();
            } else {
              tasks.toast.error(res.message);
              //this.$toast.warning(res.message)
              _this3.onCancel();
            }
          });
        } else if (this.isChangeRequest === ACCESS_TYPE_FLOW.CHANGE_METADATA) {
          if (JSON.stringify(this.objetoInicial) === JSON.stringify(this.item)) {
            this.dangerMessage = 'No change has been made to the request';
            this.dismissCountDown = this.dismissSecs;
            return;
          }
          this.$set(this.item, 'type_flow', ACCESS_TYPE_FLOW.CHANGE_METADATA);
          this.$set(this.item, 'report_id', this.item.report_id);
          var _report3 = {
            domain: window.userInfo.domain,
            comentary: responseText,
            report: this.item
          };
          DatastudioReportService.reportInitWorkFlow(_report3).then(function (res) {
            if (res && res.code === 200) {
              if (res.success) {
                tasks.toast.success('Successful request!');
                if (_this3.$gtm.enabled() && window.dataLayer) {
                  window.dataLayer.push({
                    event: GA_EVENTS.CHANGE_METADATA,
                    object: 'lds_report',
                    domain_object: _this3.item.organization,
                    operator: _this3.stringToHash(_this3.item.data_operator),
                    company_code: _this3.companyCode,
                    id_object: _this3.item.object_name,
                    hash_email: _this3.stringToHash(userInfo.email),
                    module: 'data_platform'
                  });
                }
                //this.$toast.success('Successful request')
                _this3.onCancel();
              } else {
                tasks.toast.error(res.message);
                //this.$toast.warning(res.message)
                _this3.onCancel();
              }
            }
          });
        }
      }
    },
    countDownChanged: function countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    onDownloadCsv: function onDownloadCsv() {
      var tplMeta = this.item;
      var columns = ['name'];
      var header = ['organization', 'object_name', 'kdomain', 'ksubdomain', 'data_operator', 'environment', 'path_name', 'object_owner', 'sensitive_data', 'object_description', 'datasource_name'];
      header = header.concat(columns);
      header = header.join(';');
      var body = [];
      body.push(header);
      var dataset = '';
      if (tplMeta.datasets && tplMeta.datasets.length) {
        dataset = tplMeta.datasets[0].object_name;
      }
      var data = [tplMeta.organization, tplMeta.object_name, tplMeta.kdomain, tplMeta.ksubdomain, tplMeta.data_operator, tplMeta.environment, tplMeta.path_name, tplMeta.object_owner, tplMeta.sensitive_data ? 'true' : 'false', tplMeta.object_description, dataset];
      if (tplMeta.pages && tplMeta.pages.length) {
        tplMeta.pages.forEach(function (item) {
          var row = [].concat(data);
          for (var i = 0; i < columns.length; i++) {
            row.push(item[columns[i]]);
          }
          body.push(row.join(';'));
        });
      } else {
        body.push(data.join(';'));
      }
      var a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      var universalBOM = "\uFEFF";
      var encoded = encodeURIComponent(universalBOM + body.join('\n'));
      var url = "data:text/csv; charset=utf-8,".concat(encoded);
      a.href = url;
      a.download = "Report-".concat(tplMeta.path_name, "_").concat(tplMeta.object_name, ".csv");
      a.click();
      window.URL.revokeObjectURL(url);
    },
    onUpdateTabActivate: function onUpdateTabActivate(newTabIndex, oldTabIndex, event) {
      this.txtCancelar = 'Cancel';
      this.showBtnAceptar = true;
      this.showDownloadCsv = true;
      if (newTabIndex === 1) {
        this.showDownloadCsv = false;
      }
      if (newTabIndex >= 3) {
        this.showDownloadCsv = false;
        this.txtCancelar = 'Close';
        this.showBtnAceptar = false;
      }
    }
  }
};